export default "__VITE_ASSET__DXplBaVo__"